<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <img  style="width: 100%;max-width: 450px;float: right" src="/assets/ada.png"/>
        <h1 class="mat-headline-2" i18n>Why Trust Us?</h1>
        <p i18n>At Listx, we prioritize your trust and security. Thus, in August 2023 Listx OÜ successfully completed the Cloud Application Security Assessment (CASA) Tier 2 requirements established by the App Defense Alliance.</p>
        <p i18n>The App Defense Alliance was launched in 2019 by Google, ESET, Lookout, and Zimperium with a mission to protect users from bad apps through shared intelligence and coordinated detection between alliance partners.</p>

        <br/>

        <h1 class="mat-headline-2" i18n>What is CASA?</h1>
        <p i18n>CASA is like a digital "seal of trust" that we've earned from the App Defense Alliance. Having passed the CASA assessment is proof of our reliability and integrity when it comes to keeping your data safe and respecting your privacy.</p>

        <br/>
        
        <h1 class="mat-headline-2" i18n>What Does This Mean for You?</h1>
        <ol>
          <li i18n><b>Safe Login:</b> When you use your Google account to log in or grant access to our website, you can be confident that your login credentials are safe and secure.</li>
          <li i18n><b>Your Data is Protected:</b> We go the extra mile to make sure your data is kept safe. This includes using industry standard encryption to protect your information while it's being sent and when it's stored on our servers.</li>
          <li i18n><b>Privacy First:</b> We follow all the rules and best practices to keep your data private. We respect your privacy rights and always ask for your permission before using your information.</li>
          <li i18n><b>Secure Integrations:</b> When we work with other trusted services and apps, rest assured that your data is in safe hands. We take security seriously.</li>
          <li i18n><b>We're Trustworthy:</b> Having passed the CASA requirements is a sign that you can trust us to handle your data responsibly.</li>
        </ol>
        
        <p i18n>More information on CASA, including a complete list of CASA requirements is located on the <a href="https://appdefensealliance.dev/casa/casa-requirements">App Defence Alliance Site</a>.</p>
      </div>
      
    </div>
  </div>
</div>